import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useCurrentSubscription } from '@api/hooks/useSubscription';

export function PaymentReturnPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sub = useCurrentSubscription();
  const canceled = params.get('canceled') === '1';

  const [stillPolling, setStillPolling] = useState(true);

  useEffect(() => {
    if (canceled) {
      navigate('/onboarding/payment?canceled=1', { replace: true });
      return;
    }
    if (!stillPolling) return;
    let elapsed = 0;
    const interval = setInterval(() => {
      void sub.refetch();
      elapsed += 2;
      if (elapsed >= 30) {
        setStillPolling(false);
        clearInterval(interval);
      }
    }, 2000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stillPolling, canceled, navigate]);

  useEffect(() => {
    if (sub.data?.payment_method_on_file_at) {
      navigate('/onboarding', { replace: true });
    }
  }, [sub.data, navigate]);

  if (canceled) return null;

  if (!stillPolling) {
    return (
      <div className="max-w-md mx-auto p-6 text-center">
        <p className="text-gray-700 dark:text-gray-300">
          We couldn&apos;t confirm your payment method yet.{' '}
          <a
            href="/onboarding/payment"
            className="underline text-primary-600 dark:text-primary-400"
          >
            Try again
          </a>{' '}
          or refresh this page in a moment.
        </p>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto p-6 text-center">
      <p className="text-gray-600 dark:text-gray-400">
        Confirming your payment method…
      </p>
    </div>
  );
}
